import React, { useEffect, useState } from 'react';
import { ChevronRight, Phone, Mail, Paintbrush, Ruler, LayoutGrid } from 'lucide-react';
export function CustomOrdersPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    comments: ''
  });
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section className="bg-cream" data-id="element-313">
      {/* Page Header */}
      <div className="bg-cream-dark border-b border-warmBorder" data-id="element-314">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-id="element-315">
          <nav className="flex items-center gap-2 text-sm text-warmGray mb-4" data-id="element-316">
            <a href="#/" className="hover:text-gold transition-colors" data-id="element-317">
              Home
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-318" />
            <span className="text-charcoal font-medium" data-id="element-319">Custom Orders</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-320">
            Custom &amp; Special Orders
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-321">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16" data-id="element-322">
          {/* Main Content */}
          <div className="lg:w-2/3" data-id="element-323">
            {/* Intro */}
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder mb-8" data-id="element-324">
              <h2 className="text-2xl font-serif text-charcoal mb-4" data-id="element-325">
                Can't Find What You Need?
              </h2>
              <p className="text-warmGray leading-relaxed text-lg mb-6" data-id="element-326">
                Thank you for your interest in our switchplates. We specialize
                in custom and special orders — if you don't see the size or
                configuration you need, we can likely make it for you. You can
                either email us or call us. Just complete the form below and
                we'll get back to you as quickly as possible.
              </p>
              <p className="text-warmGray leading-relaxed" data-id="element-327">
                If you prefer to call, you can reach us at{' '}
                <a href="tel:8004976946" className="text-gold hover:text-gold-dark font-bold transition-colors" data-id="element-328">
                  800.497.6946
                </a>{' '}
                Monday–Friday, 9AM to 5PM EST.
              </p>
            </div>

            {/* What We Can Do */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8" data-id="element-329">
              <div className="bg-white p-6 rounded-sm border border-warmBorder text-center" data-id="element-330">
                <div className="w-10 h-10 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-3" data-id="element-331">
                  <Ruler className="w-5 h-5 text-gold" data-id="element-332" />
                </div>
                <h3 className="font-bold text-charcoal text-sm mb-1" data-id="element-333">
                  Odd Sizes
                </h3>
                <p className="text-warmGray text-xs leading-relaxed" data-id="element-334">
                  Six-gang, blanks, despards, and unusual configurations
                </p>
              </div>
              <div className="bg-white p-6 rounded-sm border border-warmBorder text-center" data-id="element-335">
                <div className="w-10 h-10 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-3" data-id="element-336">
                  <Paintbrush className="w-5 h-5 text-gold" data-id="element-337" />
                </div>
                <h3 className="font-bold text-charcoal text-sm mb-1" data-id="element-338">
                  Custom Designs
                </h3>
                <p className="text-warmGray text-xs leading-relaxed" data-id="element-339">
                  Specific themes or designs not currently in our catalog
                </p>
              </div>
              <div className="bg-white p-6 rounded-sm border border-warmBorder text-center" data-id="element-340">
                <div className="w-10 h-10 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-3" data-id="element-341">
                  <LayoutGrid className="w-5 h-5 text-gold" data-id="element-342" />
                </div>
                <h3 className="font-bold text-charcoal text-sm mb-1" data-id="element-343">
                  Bulk Orders
                </h3>
                <p className="text-warmGray text-xs leading-relaxed" data-id="element-344">
                  Large quantities for builders, designers, or gifts
                </p>
              </div>
            </div>

            {/* Form */}
            {submitted ? <div className="bg-white p-10 md:p-14 rounded-sm shadow-sm border border-warmBorder text-center" data-id="element-345">
                <div className="w-16 h-16 mx-auto bg-sage/10 rounded-full flex items-center justify-center mb-6" data-id="element-346">
                  <Mail className="w-8 h-8 text-sage" data-id="element-347" />
                </div>
                <h2 className="text-2xl font-serif text-charcoal mb-4" data-id="element-348">
                  Request Received!
                </h2>
                <p className="text-warmGray text-lg leading-relaxed max-w-md mx-auto mb-8" data-id="element-349">
                  Thank you for your custom order inquiry. We'll review your
                  request and get back to you as quickly as possible — usually
                  within 1–2 business days.
                </p>
                <a href="#/" className="inline-flex items-center px-8 py-3.5 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm uppercase tracking-wider" data-id="element-350">
                  Continue Shopping
                </a>
              </div> : <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-351">
                <h3 className="text-xl font-serif text-charcoal mb-6" data-id="element-352">
                  Custom Order Inquiry
                </h3>

                <form onSubmit={handleSubmit} className="space-y-5" data-id="element-353">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-354">
                    <div data-id="element-355">
                      <label htmlFor="name" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-356">
                        Name <span className="text-gold" data-id="element-357">*</span>
                      </label>
                      <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="Your full name" data-id="element-358" />
                    </div>
                    <div data-id="element-359">
                      <label htmlFor="email" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-360">
                        E-Mail <span className="text-gold" data-id="element-361">*</span>
                      </label>
                      <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="your@email.com" data-id="element-362" />
                    </div>
                  </div>

                  <div data-id="element-363">
                    <label htmlFor="address" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-364">
                      Address
                    </label>
                    <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="Street address" data-id="element-365" />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-366">
                    <div data-id="element-367">
                      <label htmlFor="city" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-368">
                        City
                      </label>
                      <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="City" data-id="element-369" />
                    </div>
                    <div data-id="element-370">
                      <label htmlFor="state" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-371">
                        State
                      </label>
                      <input type="text" id="state" name="state" value={formData.state} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="State" data-id="element-372" />
                    </div>
                    <div data-id="element-373">
                      <label htmlFor="zip" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-374">
                        Zip Code
                      </label>
                      <input type="text" id="zip" name="zip" value={formData.zip} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="Zip" maxLength={10} data-id="element-375" />
                    </div>
                  </div>

                  <div data-id="element-376">
                    <label htmlFor="comments" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-377">
                      Describe Your Custom Order{' '}
                      <span className="text-gold" data-id="element-378">*</span>
                    </label>
                    <textarea id="comments" name="comments" required rows={6} value={formData.comments} onChange={handleChange} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all resize-y" placeholder="Please describe the switchplate(s) you're looking for — include size, configuration, design theme, quantity, or any other details that will help us assist you." data-id="element-379" />
                  </div>

                  <div className="pt-2" data-id="element-380">
                    <button type="submit" className="w-full sm:w-auto px-12 py-4 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm uppercase tracking-wider shadow-lg" data-id="element-381">
                      Submit Request
                    </button>
                  </div>
                </form>
              </div>}
          </div>

          {/* Sidebar */}
          <div className="lg:w-1/3" data-id="element-382">
            <div className="bg-white p-8 rounded-sm border border-warmBorder sticky top-32 shadow-warm" data-id="element-383">
              <h4 className="font-serif text-xl text-charcoal mb-6 border-b border-warmBorder pb-4" data-id="element-384">
                Prefer to Call?
              </h4>
              <p className="text-warmGray text-sm leading-relaxed mb-4" data-id="element-385">
                Our team is happy to help you figure out sizing, configurations,
                or anything else. Give us a call during business hours.
              </p>
              <a href="tel:8004976946" className="flex items-center gap-2 text-2xl font-serif text-gold hover:text-gold-dark transition-colors mb-1" data-id="element-386">
                <Phone size={20} data-id="element-387" />
                800.497.6946
              </a>
              <p className="text-xs text-warmGray mb-6" data-id="element-388">
                Monday–Friday, 9AM–5PM EST
              </p>

              <div className="pt-6 border-t border-warmBorder" data-id="element-389">
                <h4 className="font-serif text-lg text-charcoal mb-4" data-id="element-390">
                  Helpful Links
                </h4>
                <ul className="space-y-3" data-id="element-391">
                  <li data-id="element-392">
                    <a href="#/size-chart" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group text-sm" data-id="element-393">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-394" />
                      Size Chart &amp; Configurations
                    </a>
                  </li>
                  <li data-id="element-395">
                    <a href="#/faq" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group text-sm" data-id="element-396">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-397" />
                      FAQ &amp; "How To" Info
                    </a>
                  </li>
                  <li data-id="element-398">
                    <a href="#/contact" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group text-sm" data-id="element-399">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-400" />
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}